export default __webpack_public_path__ + "static/media/1492509313_weather_ios7_ios_7.ef9be0d2.png";